import { usePage } from '@inertiajs/react'
import { useEffect, useRef } from 'react'

import { flushProductEvents, identifyUser } from '@/lib/product-analytics'
import type { SharedProps } from '@/types'

/** Identifies signed-in users and flushes queued funnel events to Rybbit. */
export function ProductAnalytics() {
  const { currentUser, productEvents, analyticsConfig } = usePage<SharedProps>().props
  const lastId = useRef<string | null>(null)

  useEffect(() => {
    const id = currentUser?.id ?? null
    const previous = lastId.current
    lastId.current = id

    if (id && currentUser) {
      identifyUser(currentUser)
    } else if (previous) {
      identifyUser(null)
    }

    if (id) void flushProductEvents(productEvents, analyticsConfig)
  }, [analyticsConfig, currentUser, productEvents])

  return null
}
